import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-y_1",
  "use": "icon-y_1-usage",
  "viewBox": "0 0 40 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 28\" id=\"icon-y_1\"><defs><style>#icon-y_1 .a{fill:#fff;stroke:rgba(0,0,0,0.24);}#icon-y_1 .b{stroke:none;}#icon-y_1 .c{fill:none;}</style></defs><g class=\"a\"><rect class=\"b\" width=\"40\" height=\"28\" rx=\"2\" /><rect class=\"c\" x=\"0.5\" y=\"0.5\" width=\"39\" height=\"27\" rx=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol